import ActionLangTypes from "./lang.types";

export const langInitialState = {
  locale: "fa-IR",
  // en-US - fa-IR
};

export function langReducer(state = langInitialState, action: any) {
  switch (action.type) {
    case ActionLangTypes.CHANGE_LANGIAGE:
      return { ...state, locale: action.payload.lang };

    default:
      return { ...state };
  }
}
